import { Component, computed, inject } from '@angular/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatBadgeModule } from '@angular/material/badge';
import { MatDividerModule } from '@angular/material/divider';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SidebarService } from '../../services/sidebar.service';
import { UserService } from '../../app/core/services/user.service';
import { ThemeToggleComponent } from '../../components/theme-toggle/theme-toggle.component';

import { AuthService } from '../../app/pages/authentication/auth.service';
import { LoaderService } from '../../app/shared/components/loader/loader.service';
import { finalize } from 'rxjs';
import { RoleTransformPipe } from '../../app/shared/pipes/role-transform.pipe';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatBadgeModule,
    MatDividerModule,
    CommonModule,
    RouterModule,
    ThemeToggleComponent,
    RoleTransformPipe,
  ],
  template: `
    <mat-toolbar
      class="header-toolbar"
      [style.margin-left.px]="sidebarWidth()"
      [style.width]="'calc(100vw - ' + sidebarWidth() + 'px)'"
    >
      <button mat-icon-button (click)="toggleSidebar()" class="menu-button">
        <mat-icon>menu</mat-icon>
      </button>

      <div class="header-spacer"></div>

      <!-- Theme Toggle -->
      <app-theme-toggle></app-theme-toggle>

      <!-- <button
        mat-icon-button
        [matMenuTriggerFor]="notificationMenu"
        class="notification-button"
      >
        <mat-icon matBadge="3" matBadgeColor="warn">notifications</mat-icon>
      </button> -->

      <!-- <mat-menu #notificationMenu="matMenu">
        <button mat-menu-item>
          <mat-icon>email</mat-icon>
          <span>Nueva notificación 1</span>
        </button>
        <button mat-menu-item>
          <mat-icon>email</mat-icon>
          <span>Nueva notificación 2</span>
        </button>
        <button mat-menu-item>
          <mat-icon>email</mat-icon>
          <span>Nueva notificación 3</span>
        </button>
        <mat-divider></mat-divider>
        <button mat-menu-item>
          <mat-icon>visibility</mat-icon>
          <span>Ver todas</span>
        </button>
      </mat-menu> -->

      <button
        mat-icon-button
        [matMenuTriggerFor]="userMenu"
        class="user-button"
      >
        <div class="user-avatar" *ngIf="userService.user$ | async as user">
          <span class="user-initials">{{
            getUserInitials(user.fullName)
          }}</span>
        </div>
      </button>

      <mat-menu #userMenu="matMenu">
        <div class="user-menu-header" *ngIf="userService.user$ | async as user">
          <div class="user-menu-avatar">
            <span class="user-menu-initials">{{
              getUserInitials(user.fullName)
            }}</span>
          </div>
          <div class="user-menu-info">
            <p class="user-menu-name">{{ user.fullName }}</p>
            <p class="user-menu-role">{{ user.role.name | roleTransform }}</p>
          </div>
        </div>
        <mat-divider></mat-divider>
        <button mat-menu-item [routerLink]="['/profile']">
          <mat-icon>person</mat-icon>
          <span>My Profile</span>
        </button>

        <mat-divider></mat-divider>
        <button (click)="onLogout()" mat-menu-item>
          <mat-icon>exit_to_app</mat-icon>
          <span>Log Out</span>
        </button>
      </mat-menu>
    </mat-toolbar>
  `,
  styles: [
    `
      .header-toolbar {
        position: fixed;
        top: 0;
        right: 0;
        z-index: 1000;
        background-color: var(--color-surface) !important;
        color: var(--text-primary) !important;
        box-shadow: var(--shadow);
        transition:
          margin-left 0.3s ease,
          width 0.3s ease;
      }

      .header-toolbar mat-icon {
        color: var(--text-primary);
      }

      .header-title {
        font-size: 1.2rem;
        font-weight: 500;
        margin-left: 16px;
        color: var(--text-primary);
      }

      .header-spacer {
        flex: 1 1 auto;
      }

      .menu-button,
      .notification-button,
      .user-button,
      app-theme-toggle {
        margin-right: 8px;
        color: var(--text-primary);
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .menu-button:hover,
      .notification-button:hover,
      .user-button:hover {
        background-color: var(--color-primary);
        color: var(--text-on-primary);
      }

      .menu-button:hover mat-icon,
      .notification-button:hover mat-icon,
      .user-button:hover mat-icon {
        color: var(--text-on-primary);
      }

      .notification-button .mat-icon {
        position: relative;
      }

      .user-avatar {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background-color: var(--color-primary);
        cursor: pointer;
        transition: background-color 0.3s ease;
      }

      .user-button:hover .user-avatar {
        background-color: var(--color-primary-dark);
      }

      .user-button {
        padding: 0 !important;
        width: 40px;
        height: 40px;
      }

      .user-initials {
        color: var(--text-on-primary);
        font-size: 14px;
        font-weight: 700;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      /* User Menu Styles */
      .user-menu-header {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 12px 16px;
        background-color: color-mix(
          in srgb,
          var(--color-primary) 5%,
          transparent
        );
      }

      .user-menu-avatar {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 48px;
        height: 48px;
        border-radius: 50%;
        background-color: var(--color-primary);
        flex-shrink: 0;
      }

      .user-menu-initials {
        color: var(--text-on-primary);
        font-size: 16px;
        font-weight: 700;
      }

      .user-menu-info {
        flex: 1;
        overflow: hidden;
      }

      .user-menu-name {
        margin: 0;
        font-size: 13px;
        font-weight: 600;
        color: var(--text-primary);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .user-menu-role {
        margin: 2px 0 0 0;
        font-size: 11px;
        color: var(--text-secondary);
        text-transform: uppercase;
        letter-spacing: 0.5px;
      }

      @media (max-width: 1024px) {
        .header-title {
          font-size: 1rem;
          margin-left: 8px;
        }

        .menu-button,
        .notification-button,
        .user-button,
        app-theme-toggle {
          margin-right: 4px;
        }
      }
    `,
  ],
})
export class HeaderComponent {
  private sidebarService = inject(SidebarService);
  userService = inject(UserService);
  auth = inject(AuthService);
  sidebarWidth = this.sidebarService.layoutWidth;
  loaderSvc = inject(LoaderService);
  toggleSidebar() {
    this.sidebarService.toggleCollapse();
  }

  getUserInitials(fullName: string): string {
    const parts = fullName
      .trim()
      .split(' ')
      .filter((part) => part.length > 0);
    if (parts.length === 0) return '';
    if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
    // First letter de primer nombre + First letter de último nombre
    return (
      parts[0].charAt(0) + parts[parts.length - 1].charAt(0)
    ).toUpperCase();
  }
  onLogout() {
    this.loaderSvc.show();
    this.auth
      .logout()
      .pipe(finalize(() => this.loaderSvc.hide()))
      .subscribe();
  }
}
